import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { TreeNode } from 'primeng/api';

@Component( {
    selector: 'his-tree-select-autocomplete',
    templateUrl: './his-tree-select-autocomplete.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisTreeSelectAutocompleteComponent implements OnInit, AfterViewInit {

    // unique id for html
    @Input() uid: string;

    // minimum length of autocomplete input to trigger a search
    @Input() minLength = 1;
    // maximum number of suggestions to show in autocomplete (null -> show all)
    @Input() limit: number = null; // XXX currently unused
    // show icon to open dropdown?
    @Input() showDropdownIcon = true;
    // show null item in autocomplete select list?
    @Input() showNullItem = false;

    // the elements of the tree as a flat list, required by autocomplete
    @Input() selectList: TreeNode[];

    @Input() isFirstInputElement = false;
    @ViewChild('inputElement') inputElement: ElementRef;

    // the value of the autocomplete input field
    lastAutocompleteQuery: string = undefined;

    // suggestions for autocomplete, derived from selectList
    filteredSelectList: TreeNode[] = [];

    // element selected by autocomplete
    selectedElement: TreeNode;

    // event emitted when selectedData changes
    @Output() selected = new EventEmitter<TreeNode>();

    ngOnInit() {
        if ( this.minLength === 0 ) {
            // if minLength==0 then we must initialize filteredSelectList from the start
            this.filteredSelectList = this.selectList;
            this.lastAutocompleteQuery = '';
        }
    }

    ngAfterViewInit() {
        // Set focus on first input element
        if (this.isFirstInputElement) {
            setTimeout( () => this.inputElement.nativeElement.focus() );
        }
    }

    filterSelectList( $event: { query: string } ) {
        let autocompleteQuery = $event.query;
        console.log( 'HisTreeSelectAutocompleteComponent.filterSelectList(): event =',
            $event, ', query =', autocompleteQuery, ', lastAutocompleteQuery =', this.lastAutocompleteQuery );
        // Produce filteredSelectList:
        // * If the new query contains the previous one, then we filter the last filtering result again
        // * If the new query does not contain the last one (because some characters were removed from the
        //   autocomplete input field), then we have process the complete list
        // * Case is ignored.
        let lastList = this.lastAutocompleteQuery && autocompleteQuery.indexOf( this.lastAutocompleteQuery ) > -1
            ? this.filteredSelectList : this.selectList;
        let nextList = [];
        let listElem: TreeNode;
        for ( listElem of lastList ) {
            if ( listElem?.data?.defaulttext.toUpperCase().indexOf( autocompleteQuery.toUpperCase() ) > -1 ) {
                nextList.push( listElem );
            }
        }
        this.filteredSelectList = nextList;
        this.lastAutocompleteQuery = autocompleteQuery;
    }

    /**
     * Pass element selected to wrapping component.
     */
    emitSelectedElement() {
        this.selected.emit( this.selectedElement );
    }
}
